import { DependencyList, useEffect } from 'react'

type ListenerType = (this: Window, ev: UIEvent) => void

const useOnResize = (listener: ListenerType, deps: DependencyList = []) => {
  useEffect(() => {
    window.addEventListener('resize', listener)
    return () => window.removeEventListener('resize', listener)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listener, ...deps])
}

export default useOnResize
